// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"15ba4e2a","239":"b7e6113e","453":"47845485","455":"e9b201b9"}[chunkId] + ".chunk.js";
};